import { useEffect, useState } from 'react';

/*
 * Family portal breakpoint: the designs are mobile 440 and desktop 1720, and
 * the desktop compositions (record and task flyouts over Your children) are
 * different structures, not stretched phone layouts — so pages switch
 * composition at 1100px, matching the harbour css breakpoints. Defaults to
 * mobile where matchMedia is unavailable (jsdom).
 */
const QUERY = '(min-width: 1100px)';

export default function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(() => {
    try {
      return typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(QUERY).matches;
    } catch (_) {
      return false;
    }
  });

  useEffect(() => {
    let mql;
    try {
      if (typeof window === 'undefined' || !window.matchMedia) return undefined;
      mql = window.matchMedia(QUERY);
    } catch (_) {
      return undefined;
    }
    const onChange = (e) => setIsDesktop(e.matches);
    setIsDesktop(mql.matches);
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else if (mql.addListener) mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else if (mql.removeListener) mql.removeListener(onChange);
    };
  }, []);

  return isDesktop;
}
